import React from "react"
import { Plus } from "lucide-mui"
import i18n from "@/i18n"

interface AddPhotoButtonProps {
  onFileSelect: (file: File) => void
}

const STYLES = {
  container: "relative w-full pb-[50%]",
  label:
    "absolute inset-0 border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-gray-500 hover:bg-gray-50 transition-colors",
  icon: "w-12 h-12 text-gray-400 mb-2",
  text: "text-gray-500 text-sm",
} as const

const AddPhotoButton: React.FC<AddPhotoButtonProps> = ({ onFileSelect }) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      onFileSelect(file)
      event.target.value = ""
    }
  }

  return (
    <div className={STYLES.container} data-testid="settings-venue-photos-add-btn">
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="add-venue-photo"
        data-testid="settings-venue-photos-add-btn-input"
      />
      <label htmlFor="add-venue-photo" className={STYLES.label}>
        <Plus className={STYLES.icon} />
        <span className={STYLES.text}>{i18n.t("app.settings.venues.tabbio.photos.add_photo")}</span>
      </label>
    </div>
  )
}

export default AddPhotoButton
